import ToolbarButton from "@/components/ToolbarButton";
import { ButtonProps } from "@/components/ui/button";
import useSurvey from "@/containers/survey/hooks/useSurvey";
import { cn } from "@/lib/utils";
import { SquarePlus } from "lucide-react";
import { forwardRef } from "react";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface AddQuestionButtonProps extends ButtonProps {
  className?: string;
  labelClassName?: string;
  insertAt?: number;
  label?: string;
}

export default forwardRef<HTMLButtonElement, AddQuestionButtonProps>(
  function AddQuestionButton(
    { label, labelClassName, insertAt, ...props }: AddQuestionButtonProps,
    ref,
  ) {
    const { t } = useTranslation();
    const survey = useSurvey();

    const { isSubmitting, disabled } = useFormState();

    const onClick = () => {
      survey.addQuestion({
        insertAt,
      });
    };

    return (
      <ToolbarButton
        type="button"
        onClick={onClick}
        ref={ref}
        disabled={isSubmitting || disabled}
        {...props}
      >
        <SquarePlus className="w-5 h-5" />
        <span className={cn("ml-3", labelClassName)}>
          {label ? label : t("surveyEditor.toolbar.addQuestion")}
        </span>
      </ToolbarButton>
    );
  },
);
